<template>
    <div v-if="user">
        <md-tabs md-sync-route>
            <md-tab 
                id="tab-users" 
                md-label="Users" 
                to="/admin/users" 
                exact
            >
                <router-view></router-view>
            </md-tab>

            <!-- <md-tab
                id="tab-features"
                md-label="Organisation features"
                to="/admin/features"
            >
                <router-view></router-view>
            </md-tab> -->

            <md-tab
                v-if="isSuperAdmin"
                id="tab-organisations"
                md-label="Organisations"
                to="/admin/organisations"
            >
                <router-view></router-view>
            </md-tab>

           
        </md-tabs>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AuthService } from "../services/auth.service";

export default {
    name: "Admin",
    data: () => ({
        user: null,
    }),
    created() {
        this.subscription = AuthService.loggedUser$.subscribe(
            (user) => (this.user = user)
        );
    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    },
    computed: {
        isSuperAdmin() {
            return this.user.roles && this.user.roles.includes("superadmin");
        },
    },
};
</script>